
[
  {
    "id": "TG-B8-001",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Een auto rijdt 90 km per uur. Hoeveel kilometer legt hij af in 2,5 uur?",
    "options": ["225 km", "180 km", "200 km", "250 km"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-AUTO",
    "explanation": "Afstand = snelheid × tijd. 90 × 2,5 = 225 km. Of: 90 × 2 = 180, plus 90 × 0,5 = 45. Samen 225.",
    "distractorExplanations": { "1": "Dit is de afstand in 2 uur (90 × 2).", "2": "Rekenfout: 90 × 2,5 is niet 200.", "3": "Dit is de afstand in bijna 3 uur." }
  },
  {
    "id": "TG-B8-002",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "In een grafiek zie je dat de temperatuur om 8:00 uur 5°C was en om 14:00 uur 17°C. Hoeveel graden is de temperatuur gestegen?",
    "options": ["12°C", "17°C", "22°C", "5°C"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-GRAFIEK-TEMP",
    "explanation": "De stijging is 17 - 5 = 12°C. Je trekt de begintemperatuur af van de eindtemperatuur.",
    "distractorExplanations": { "1": "17°C is de eindtemperatuur, niet de stijging.", "2": "Je telde de twee temperaturen bij elkaar op.", "3": "5°C is de begintemperatuur, niet de stijging." }
  },
  {
    "id": "TG-B8-003",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Een trein rijdt 120 km/u. Een fiets rijdt 20 km/u. Hoeveel keer sneller is de trein dan de fiets?",
    "options": ["6 keer", "100 keer", "5 keer", "10 keer"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-VERGELIJK",
    "explanation": "120 : 20 = 6. De trein is 6 keer zo snel als de fiets.",
    "distractorExplanations": { "1": "Je trok af (120 - 20 = 100), maar je moet delen.", "2": "Rekenfout.", "3": "120 : 20 = 6, niet 10." }
  },
  {
    "id": "TG-B8-004",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "In een staafdiagram staat het aantal leerlingen per sport:\nVoetbal: 45, Tennis: 20, Zwemmen: 35, Hockey: 30.\n\nHoeveel leerlingen doen er in totaal mee?",
    "options": ["130", "100", "120", "150"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-STAAF-SPORT",
    "explanation": "45 + 20 + 35 + 30 = 130 leerlingen in totaal.",
    "distractorExplanations": { "1": "Je bent een of meer sporten vergeten.", "2": "Rekenfout bij het optellen.", "3": "Je telde er te veel bij op." }
  },
  {
    "id": "TG-B8-005",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Een fietser rijdt 15 km in 1 uur. Hoeveel minuten doet hij over 5 km?",
    "options": ["20 minuten", "15 minuten", "30 minuten", "25 minuten"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-FIETS-MIN",
    "explanation": "15 km in 60 minuten. 1 km duurt 60 : 15 = 4 minuten. 5 km duurt 5 × 4 = 20 minuten.",
    "distractorExplanations": { "1": "15 is de snelheid in km/u, niet de tijd.", "2": "30 minuten is de helft van een uur, maar 5 km is een derde van 15 km.", "3": "Rekenfout." }
  },
  {
    "id": "TG-B8-006",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "In een lijndiagram stijgt de lijn van 10 naar 50 in 4 uur. Hoeveel stijging per uur?",
    "options": ["10 per uur", "50 per uur", "12,5 per uur", "40 per uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-LIJN-STIJGING",
    "explanation": "De stijging is 50 - 10 = 40. Verdeeld over 4 uur: 40 : 4 = 10 per uur.",
    "distractorExplanations": { "1": "50 is de eindwaarde, niet de stijging per uur.", "2": "Je deelde 50 door 4, maar je moet eerst het verschil berekenen.", "3": "40 is de totale stijging, niet per uur." }
  },
  {
    "id": "TG-B8-007",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Een vliegtuig vliegt 800 km/u. Het moet 2400 km vliegen. Hoe lang duurt de vlucht?",
    "options": ["3 uur", "2 uur", "4 uur", "3,5 uur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-VLIEGTUIG",
    "explanation": "Tijd = afstand : snelheid. 2400 : 800 = 3 uur.",
    "distractorExplanations": { "1": "2 × 800 = 1600, dat is te weinig.", "2": "4 × 800 = 3200, dat is te veel.", "3": "3,5 × 800 = 2800, dat is te veel." }
  },
  {
    "id": "TG-B8-008",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Een tabel toont het waterverbruik per dag:\nMaandag: 120 liter, Dinsdag: 95 liter, Woensdag: 110 liter.\n\nWat is het gemiddelde waterverbruik per dag?",
    "options": ["Ongeveer 108 liter", "Ongeveer 120 liter", "Ongeveer 95 liter", "Precies 100 liter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "tabellen_lezen",
    "familyId": "TG-TABEL-WATER",
    "explanation": "Totaal: 120 + 95 + 110 = 325. Gemiddeld: 325 : 3 ≈ 108 liter.",
    "distractorExplanations": { "1": "120 is alleen het verbruik op maandag.", "2": "95 is alleen het verbruik op dinsdag.", "3": "100 is een afronding, maar 325 : 3 is dichter bij 108." }
  },
  {
    "id": "TG-B8-009",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "Als je 60 km/u rijdt, hoeveel meter leg je dan af per seconde?",
    "options": ["Ongeveer 17 meter", "Ongeveer 60 meter", "Ongeveer 10 meter", "Ongeveer 100 meter"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-SNELHEID-MS",
    "explanation": "60 km/u = 60.000 meter per uur. Per seconde: 60.000 : 3600 ≈ 16,7 meter, dus ongeveer 17 meter.",
    "distractorExplanations": { "1": "60 is de snelheid in km/u, niet in m/s.", "2": "10 m/s zou 36 km/u zijn.", "3": "100 m/s zou 360 km/u zijn." }
  },
  {
    "id": "TG-B8-010",
    "module": "TijdGeld",
    "difficulty": 301,
    "question": "In een cirkeldiagram is 25% rood, 50% blauw en de rest groen. Hoeveel procent is groen?",
    "options": ["25%", "30%", "20%", "15%"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "grafieken",
    "subSkill": "grafieken_lezen",
    "familyId": "TG-CIRKEL-PROCENT",
    "explanation": "Een cirkeldiagram is altijd 100%. Rood (25%) + Blauw (50%) = 75%. Groen = 100% - 75% = 25%.",
    "distractorExplanations": { "1": "25 + 50 + 30 = 105%, dat is meer dan 100%.", "2": "25 + 50 + 20 = 95%, dat is minder dan 100%.", "3": "25 + 50 + 15 = 90%, dat is minder dan 100%." }
  }
]
